import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import { theme } from 'theme';

export const AppWrapper = styled(Box)`
  display: block;
  min-height: 240px;
  height: auto;
  position: relative;
  margin: 0 8px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    min-height: 195px;
    margin: 0;
  }

  .page-title {
    font-size: 80px;
    line-height: 80px;
    padding-top: 25px;

    ${({ theme }) => theme.breakpoints.down('md')} {
      font-size: 36px;
      line-height: 40px;
      padding-top: 0;
    }
  }
`;

export const BannersList = styled(Grid)`
  padding: 0.5em;
  margin-bottom: 1.5em;
  min-height: 210px;
  .MuiGrid-item > a > div {
    background-color: ${theme.palette.grey[50]};
  }
`;

// export const ResultsContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: flex-start;
// `;
//
// export const ResultsWrapper = styled(Box)`
//   width: 100%;
// `;
//
// export const ResultsHeaderWrapper = styled(Box)`
//   background: ${theme.palette.common.white};
//   position: relative;
// `;
//
// export const SearchingOverlay = styled(Box)`
//   width: 100%;
//   height: 100%;
//   display: flex;
//   justifycontent: center;
//   alignitems: flex-start;
//   position: absolute;
//   backgroundcolor: ${theme.rgba(theme.palette.common.white, 0.3)};
//   zindex: 10000;
//   pointerevents: all;
// `;
//
// export const LoadingIcon = styled(CircularProgress)`
//   color: ${theme.palette.grey[400]};
//   margin-top: 20%;
// `;
//
// export const FilterWrapper = styled(Box, {
//   shouldForwardProp: (prop) => !['isFilterShown', 'isFilterRemoved'].includes(prop)
// })`
//   width: ${(props) => (props.isFilterShown ? '210px' : '0')};
//   margin-right: ${(props) => (props.isFilterShown ? '24px' : '0')};
//   visibility: ${(props) => (props.isFilterShown ? 'visible' : 'hidden')};
//   position: relative;
//   left: ${(props) => (props.isFilterShown ? '0' : '-40em')};
//   flex-grow: 0;
//   flex-shrink: 0;
//   flex-direction: column;
//   background: ${theme.palette.common.white};
//   display: ${({ isFilterRemoved }) => isFilterRemoved ? 'none' : 'flex'};
//   .sticky-inner-wrapper {
//     width: 100% !important;
//     background: ${theme.palette.common.white};
//     max-width: ${(props) => (props.isFilterShown ? '210px' : '0')};
//   }
//   ${theme.breakpoints.up('lg')} {
//     padding: 0;
//   }
//   ${theme.breakpoints.down('lg')} {
//     position: absolute;
//     top: 3em;
//     z-index: 100;
//     width: ${(props) => (props.isFilterShown ? '100%' : '0')};
//     margin-right: 0;
//     .sticky-inner-wrapper {
//       max-width: none;
//     }
//   }
// `;
//
// export const SelectedFiltersList = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: flex-start;
//   justify-content: flex-start;
//   width: 100%;
//   ${theme.breakpoints.down('md')} {
//     display: none;
//   }
// `;
//
// export const SearchFormWrapper = styled.div`
//     width: 100vw;
//     margin-left: -50vw;
//     margin-right: -50vw;
//     left: 50%;
//     right: 50%;
//     position: relative;
//     margin-bottom: 2em;
// `;
//
// export const SearchAutocompleteResults = styled.div`
//   position: relative;
//   width: 100%;
//   z-index: 100;
// `;
